module.exports = __webpack_public_path__ + "img/option-chain-icon.3e07933c.svg";